import React, { useContext } from "react";
import { MenuSelection } from "../../../components/menuButtons/MenuSelection";
import { SaveImage } from "../../../components/SaveImage";
import { Loader } from "../../../components/loader/Loader";
import { LocalStoreContext } from "../store/LocalStore";
import { StoreContext } from "../../../store/Store";
import { RefContext } from "../store/RefContext";

export const Controls = () => {
  const [store] = useContext(StoreContext);
  const [lstore] = useContext(LocalStoreContext);
  const { horizon, loading } = lstore;
  const refs = useContext(RefContext);
  const { defaultTicker } = store;
  return (
    <div
      style={{
        height: refs.componentSize.current["Controls"].height,
        width: refs.componentSize.current["Controls"].width - 17,
        margin: 0,
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        gap: 0,
      }}
    >
      {/* <HorizonSelection /> */}
      {!loading && (
        <SaveImage
          label="Download V-Scores"
          prefix="V-Score"
          selectkeys={["horizon", "spiderTicker"]}
          svgRef={refs.spiderRef}
        />
      )}
      <div style={{ width: 30 }}></div>
      <MenuSelection
        menukey="horizon"
        defaultSelection={"21"}
        label="Horizon"
        inputType="radio"
        data={horizon.rawdata}
      />
      <div style={{ width: 30 }}>{loading && <Loader width={20} />}</div>
      <MenuSelection
        menukey="spiderTicker"
        defaultSelection={defaultTicker}
        label="Ticker"
        inputType="radio"
        data={horizon.rawdata}
      />
    </div>
  );
};
